'use client';

import { Theme, responsiveFontSizes } from '@mui/material';
import { createTheme, ComponentsOverrides } from '@mui/material/styles';
import shadows from './shadows';
import { light, dark } from './palette';

const theme = (mode: string, themeToggler?: () => void) =>
  createTheme({
    palette: mode === 'light' ? light : dark,
    shadows: shadows(mode),
    typography: {
      fontFamily: '"Inter", sans-serif',
      button: {
        textTransform: 'none',
        fontWeight: 'medium' as React.CSSProperties['fontWeight'],
      },
      code: {
        backgroundColor: light.primary.main,
        //       // color: theme('colors.red.500'),
        //       // padding: theme('spacing.1'),
        //       // borderRadius: theme('borderRadius.sm'),
        //       // fontWeight: theme('fontWeight.medium'),
        wordBreak: 'break-all',
      },
      h4: {
        fontSize: '24px',
        fontWeight: 700,
      },
      h5: {
        fontSize: '20px',
        fontWeight: 500,
      },
      body1: {
        fontSize: '14px',
        fontWeight: 400,
      },
      subtitle1: {
        fontSize: '14px',
        fontWeight: 700,
      },
    },
    zIndex: {
      appBar: 1200,
      drawer: 1300,
    },
    components: {
      // MuiTypography: {
      //   styleOverrides: {
      //     code: {
      //       // backgroundColor: theme('colors.gray.100'),
      //       // color: theme('colors.red.500'),
      //       // padding: theme('spacing.1'),
      //       // borderRadius: theme('borderRadius.sm'),
      //       // fontWeight: theme('fontWeight.medium'),
      //       wordBreak: 'break-all',
      //     },
      //   },
      // },
      MuiButton: {
        styleOverrides: {
          root: {
            fontWeight: 400,
            borderRadius: 5,
            paddingTop: 10,
            paddingBottom: 10,
          },
          containedSecondary: mode === 'light' ? { color: 'white' } : {},
        } as ComponentsOverrides['MuiButton'],
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            borderRadius: 5,
          },
        } as ComponentsOverrides['MuiInputBase'],
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 5,
          },
          input: {
            borderRadius: 5,
          },
        } as ComponentsOverrides['MuiOutlinedInput'],
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        } as ComponentsOverrides['MuiCard'],
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            '& .MuiTableCell-root': {
              fontWeight: 'bold',
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            border: '1px solid rgba(224, 224, 224, 1)',
          },
        } as ComponentsOverrides['MuiTableCell'],
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            '& .MuiFormControl-root': {
              marginBottom: 0,
              marginTop: 0,
            },
          },
        },
      },
      // MuiTable: {
      //   styleOverrides: {
      //     root: {
      //       border: '1px solid #ccc',
      //       borderCollapse: 'separate',
      //     },
      //   },
      // },
      // MuiTableBody: {
      //   styleOverrides: {
      //     root: {
      //       borderBottomLeftRadius: '16px',
      //       borderBottomRightRadius: '16px',
      //     },
      //   },
      // },
      // MuiTableRow: {
      //   styleOverrides: {
      //     root: {
      //       '&:first-child': {
      //         '& > *:first-child': {
      //           borderTopLeftRadius: '16px',
      //         },
      //         '& > *:last-child': {
      //           borderTopRightRadius: '16px',
      //         },
      //       },
      //       '&:last-child': {
      //         '& > *:first-child': {
      //           borderBottomLeftRadius: '16px',
      //         },
      //         '& > *:last-child': {
      //           borderBottomRightRadius: '16px',
      //         },
      //       },
      //     },
      //   },
      // },
    },
    themeToggler,
  });
const getTheme = (mode: string, themeToggler?: () => void): Theme =>
  responsiveFontSizes(theme(mode, themeToggler));

export default getTheme;

const lightTheme = theme('light');
export { theme, lightTheme };
